$shm_hitalama_map_book_tools $mol_view
	tool_mode? \
	sub /
		<= Drawing $mol_check_icon
			checked? <=> drawing_checked? false
			Icon <= Drawing_icon $mol_icon_pencil
		<= Rect $mol_check_icon
			checked? <=> rect_checked? false
			Icon <= Rect_icon $mol_icon_rectangle_outline
		<= Circle $mol_check_icon
			checked? <=> circle_checked? false
			Icon <= Circle_icon $mol_icon_circle_outline
